import React, { useState } from "react";
import "./App.css";
import Dashboard from "./components/Dashboard";
import BusinessPostGenerator from "./components/BusinessPostGenerator";
import HiringPostGenerator from "./components/HiringPostGenerator";
import FestivalWishesGenerator from "./components/FestivalWishesGenerator";
import OutreachEmailGenerator from "./components/OutreachEmailGenerator";
import HashtagGenerator from "./components/HashtagGenerator";
import PostingTimeGenerator from "./components/PostingTimeGenerator";

function App() {
  const [activeTab, setActiveTab] = useState("business-post");

  const tabs = [
    {
      id: "business-post",
      label: "Business Post",
      component: BusinessPostGenerator,
    },
    { id: "hiring-post", label: "Hiring Post", component: HiringPostGenerator },
    {
      id: "festival-wishes",
      label: "Festival Wishes",
      component: FestivalWishesGenerator,
    },
    {
      id: "outreach-email",
      label: "Outreach Email",
      component: OutreachEmailGenerator,
    },
    { id: "hashtags", label: "Hashtags", component: HashtagGenerator },
    {
      id: "posting-time",
      label: "Posting Time",
      component: PostingTimeGenerator,
    },
  ];

  const ActiveComponent =
    tabs.find((tab) => tab.id === activeTab)?.component ||
    BusinessPostGenerator;

  return (
    <div className="App">
      {/* ===== Header ===== */}
      <header className="app-header">
        <div className="header-left">
          <img src="/logo.png" alt="B2World Logo" className="app-logo" />
          <div className="header-text">
            <h1>AI Content Generator</h1>
            <p className="subtitle">Powered by B2World Branding</p>
          </div>
        </div>
      </header>

      {/* ===== Tabs ===== */}
      <Dashboard
        tabs={tabs}
        activeTab={activeTab}
        setActiveTab={setActiveTab}
      />

      {/* ===== Content ===== */}
      <main className="main-content">
        <ActiveComponent />
      </main>
    </div>
  );
}

export default App;
